import { AnnouncementPage } from './AnnouncementPage';
export default AnnouncementPage;
